export default {"src":"/_next/static/media/quote-icon-1.2ea2ed50.svg","height":340,"width":413};